/**
 * Логотипы банков — значок счёта «как в приложении банка».
 *
 * Карту узнают по логотипу быстрее, чем по названию: «Т-Банк» и «Альфа» в
 * списке из пяти счетов различаются цветом и знаком, а не буквами. Логотипы
 * взяты с официальных сайтов банков (значок сайта или приложения) и лежат в
 * `assets/banks/` — это картинки, а не иконки Font Awesome, поэтому рисуются
 * `<img>` на белой плашке: у части логотипов прозрачный фон.
 *
 * В счёте хранится `bank:<id>` — так значок банка не спутать с именем иконки.
 */
import akbars from './assets/banks/akbars.png';
import alfa from './assets/banks/alfa.png';
import bspb from './assets/banks/bspb.png';
import gpb from './assets/banks/gpb.svg';
import mkb from './assets/banks/mkb.png';
import modul from './assets/banks/modul.png';
import mts from './assets/banks/mts.svg';
import otp from './assets/banks/otp.png';
import ozon from './assets/banks/ozon.png';
import psb from './assets/banks/psb.png';
import raif from './assets/banks/raif.svg';
import renins from './assets/banks/renins.png';
import rosbank from './assets/banks/rosbank.png';
import rshb from './assets/banks/rshb.png';
import sber from './assets/banks/sber.png';
import sovcom from './assets/banks/sovcom.png';
import tbank from './assets/banks/tbank.png';
import tochka from './assets/banks/tochka.svg';
import vtb from './assets/banks/vtb.svg';
import wb from './assets/banks/wb.png';

export interface Bank { id: string; name: string; src: string }

/** Порядок — примерно по тому, у скольких людей карта этого банка. */
export const BANKS: readonly Bank[] = [
  { id: 'sber', name: 'Сбербанк', src: sber },
  { id: 'tbank', name: 'Т-Банк', src: tbank },
  { id: 'alfa', name: 'Альфа-Банк', src: alfa },
  { id: 'vtb', name: 'ВТБ', src: vtb },
  { id: 'ozon', name: 'Озон Банк', src: ozon },
  { id: 'wb', name: 'Вайлдберриз Банк', src: wb },
  { id: 'gpb', name: 'Газпромбанк', src: gpb },
  { id: 'raif', name: 'Райффайзенбанк', src: raif },
  { id: 'sovcom', name: 'Совкомбанк', src: sovcom },
  { id: 'mts', name: 'МТС Банк', src: mts },
  { id: 'psb', name: 'ПСБ', src: psb },
  { id: 'rshb', name: 'Россельхозбанк', src: rshb },
  { id: 'otp', name: 'ОТП Банк', src: otp },
  { id: 'mkb', name: 'МКБ', src: mkb },
  { id: 'bspb', name: 'Банк «Санкт-Петербург»', src: bspb },
  { id: 'akbars', name: 'Ак Барс Банк', src: akbars },
  { id: 'rosbank', name: 'Росбанк', src: rosbank },
  { id: 'renins', name: 'Ренессанс Банк', src: renins },
  { id: 'tochka', name: 'Точка', src: tochka },
  { id: 'modul', name: 'Модульбанк', src: modul },
];

const PREFIX = 'bank:';

/** Значение значка для банка. */
export const bankIcon = (id: string): string => `${PREFIX}${id}`;

/** Банк значка; `undefined` — значок не банковский или банк неизвестен. */
export function bankOf(icon: string | undefined | null): Bank | undefined {
  if (!icon?.startsWith(PREFIX)) return undefined;
  const id = icon.slice(PREFIX.length);
  return BANKS.find((b) => b.id === id);
}
